<template>
  <v-container class="modern-view pb-12">
    <!-- Premium Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm border-white-sm">
          <v-icon color="white">leaderboard</v-icon>
        </v-avatar>
        <div>
          <div class="text-h4 font-weight-black primary--text lh-1">Ventas por <span class="secondary--text">Familia</span></div>
          <div class="caption grey--text font-weight-bold uppercase tracking-widest mt-1">Ranking estratégico por categorías de producto</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <export-sales-by-family :data="family"/>
      </div>
    </v-row>

    <!-- Metrics Ranking Row (Graphs) -->
    <!-- <v-row class="mb-8 px-2">
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card h-100 overflow-hidden shadow-sm">
          <div class="pa-4 bg-lightgrey border-bottom d-flex align-center">
            <v-avatar size="24" color="primary lighten-5" class="mr-2">
              <v-icon x-small color="primary">fas fa-money-bill-wave</v-icon>
            </v-avatar>
            <span class="caption font-weight-black uppercase grey--text">Top 5 Familias: Venta</span>
          </div>
          <div class="pa-4">
            <sales-product-graph 
              :data="sortedData.bySales" 
              :values="sortedData.bySales.map(d=>d.total_sales)"
              :height="150"
              title=""
            />
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card h-100 overflow-hidden shadow-sm">
          <div class="pa-4 bg-lightgrey border-bottom d-flex align-center">
            <v-avatar size="24" color="secondary lighten-5" class="mr-2">
              <v-icon x-small color="secondary">fas fa-square-root-alt</v-icon>
            </v-avatar>
            <span class="caption font-weight-black uppercase grey--text">Top 5 Familias: Mts²</span>
          </div>
          <div class="pa-4">
            <sales-product-graph 
              :data="sortedData.byMts2" 
              :values="sortedData.byMts2.map(d=>d.total_mts2)"
              :height="150"
              title=""
            />
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card h-100 overflow-hidden shadow-sm">
          <div class="pa-4 bg-lightgrey border-bottom d-flex align-center">
            <v-avatar size="24" color="orange lighten-5" class="mr-2">
              <v-icon x-small color="orange darken-2">fas fa-boxes</v-icon>
            </v-avatar>
            <span class="caption font-weight-black uppercase grey--text">Top 5 Familias: Cantidad</span>
          </div>
          <div class="pa-4">
            <sales-product-graph 
              :data="sortedData.byQty" 
              :values="sortedData.byQty.map(d=>d.total_qty)"
              :height="150"
              title=""
            />
          </div>
        </v-card>
      </v-col>
    </v-row> -->

    <!-- Modern Filters Card -->
    <v-card outlined class="modern-card pa-6 mb-8 shadow-sm">
      <v-row dense align="end">
        <v-col cols="12" md="3">
          <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Fecha Desde</div>
          <v-text-field 
            hide-details 
            :disabled="loading" 
            dense 
            v-model='filter.created_after' 
            outlined 
            type="date" 
            class="modern-input"
          />
        </v-col>
        <v-col cols="12" md="3">
          <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Fecha Hasta</div>
          <v-text-field 
            hide-details 
            :disabled="loading" 
            dense 
            v-model='filter.created_before' 
            clearable 
            outlined 
            type="date" 
            class="modern-input"
          />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="auto" class="d-flex pb-1">
          <v-btn color="primary" icon class="grey lighten-4 shadow-xs" @click="fetch" :loading="loading">
            <v-icon small>fas fa-sync</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Main Table Card -->
    <v-card outlined class="modern-card overflow-hidden shadow-sm">
      <v-data-table
        :headers="headers"
        :items="family"
        :loading="loading"
        :search="search"
        class="modern-table"
        sort-by="total_sales"
        :sort-desc="true"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50, 100],
        }"
      >
        <!-- Integrated Search Header -->
        <template v-slot:top>
          <v-sheet color="bg-lightgrey" class="px-6 py-4 d-flex align-center border-bottom bg-lightgrey">
            <span class="caption font-weight-black uppercase tracking-widest grey--text">Desempeño de Ventas por Familia ({{ family.length }})</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              placeholder="Buscar familia o línea..."
              prepend-inner-icon="fas fa-search"
              outlined dense hide-details clearable
              :disabled="loading"
              class="modern-search-field"
            ></v-text-field>
          </v-sheet>
        </template>

        <template v-slot:item.id="{ item }">
          <v-chip x-small label dark color="secondary" class="font-weight-black">{{ item.id }}</v-chip>
        </template>

        <template v-slot:item.name="{ item }">
          <div class="body-2 font-weight-black primary--text lh-1-2 py-2">{{ item.name }}</div>
        </template>

        <template v-slot:item.line="{ item }">
          <span class="caption grey--text font-weight-bold uppercase">{{ item.line }}</span>
        </template>

        <template v-slot:item.total_mts2="{ item }">
          <span class="body-2 font-weight-medium">{{ item.total_mts2 | number('0,0.00') }}</span>
          <span class="caption grey--text ml-1 text-lowercase">m²</span>
        </template>

        <template v-slot:item.total_qty="{ item }">
          <span class="body-2 font-weight-black">{{ item.total_qty | number('0,0') }}</span>
        </template>

        <template v-slot:item.total_sales="{ item }">
          <div class="body-1 font-weight-black secondary--text tracking-tighter">{{ item.total_sales | moneda }}</div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {fetchProductionProducts} from '@/api/reports'
import SalesProductGraph from '@/components/reports/SalesProductGraph'
import ExportSalesByFamily from '@/components/reports/ExportSalesByFamily'
import moment from 'moment'

export default {
  name: "FamilySalesReport",
  components: {
    SalesProductGraph,
    ExportSalesByFamily
  },
  data() {
    return {
      loading: false,
      filter: {
        created_after: moment().startOf('month').format('YYYY-MM-DD'),
        created_before: '',
      },
      search: '',
      family: [],
      headers: [
        { text: 'Código', align: 'start', value: 'id', class: 'table-header', width: '110px' },
        { text: 'Familia de Producto', align: 'start', value: 'name', class: 'table-header' },
        { text: 'Línea Negocio', align: 'start', value: 'line', class: 'table-header', width: '180px' },
        { text: 'Volumen Mts²', align: 'end', value: 'total_mts2', class: 'table-header', width: '130px' },
        { text: 'Unidades', align: 'end', value: 'total_qty', class: 'table-header', width: '100px' },
        { text: 'Venta Neto', align: 'end', value: 'total_sales', class: 'table-header', width: '160px' },
      ]
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      let created_before = ''
      let created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('YYYY-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().endOf('day').format('YYYY-MM-DD HH:mm')

      try {
        const res = await fetchProductionProducts(created_after, created_before)
        this.family = this.processData(res)
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    processData(rawProducts) {
      let uniqueFamilies = [...new Set(rawProducts.map(item => item.family))];
      return uniqueFamilies.map(familyId => {
        const items = rawProducts.filter(p => p.family == familyId)
        return {
          id: familyId,
          name: items[0].family_name,
          line: items[0].line_name,
          total_sales: items.reduce((acc, val) => acc + parseFloat(val.total_sales_price || 0), 0),
          total_mts2: items.reduce((acc, val) => acc + parseFloat(val.mts2 || 0), 0),
          total_qty: items.reduce((acc, val) => acc + parseFloat(val.qty || 0), 0),
        }
      })
    }
  },
  watch: {
    filter: {
      deep: true,
      handler: 'fetch'
    },
  },
  computed: {
    sortedData() {
      const fams = [...this.family]
      return {
        bySales: [...fams].sort((a, b) => b.total_sales - a.total_sales).slice(0, 5),
        byMts2: [...fams].sort((a, b) => b.total_mts2 - a.total_mts2).slice(0, 5),
        byQty: [...fams].sort((a, b) => b.total_qty - a.total_qty).slice(0, 5)
      }
    }
  }
}
</script>

<style scoped>
.modern-view { background-color: #f4f7f9; min-height: 100vh; }

/* Modern Card Styles */
.modern-card { 
  border-radius: 12px !important; 
  border: 1px solid rgba(0,0,0,0.05) !important; 
  background-color: white !important; 
}
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; }
.shadow-xs { box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important; }

/* Table Styling */
.modern-table >>> thead th {
  background-color: #f8fbfc !important;
  height: 56px !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 1px;
  font-weight: 900 !important;
  color: #607d8b !important;
  border-bottom: 2px solid #edf1f4 !important;
}
.modern-table >>> td {
  height: 60px !important;
  border-bottom: 1px solid #f0f3f5 !important;
}

/* Input Styling */
.modern-input >>> .v-input__control >>> .v-input__slot {
  background-color: #f8fbfc !important;
  border-radius: 8px !important;
}
.modern-search-field { max-width: 400px; }
.modern-search-field >>> .v-input__control >>> .v-input__slot {
  background-color: white !important;
  border-radius: 12px !important;
}

/* Utilities */
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
.bg-lightgrey { background-color: #f8fbfc; }
.lh-1 { line-height: 1 !important; }
.lh-1-2 { line-height: 1.25 !important; }
.uppercase { text-transform: uppercase; letter-spacing: 0.8px; }
.tracking-widest { letter-spacing: 1.8px; }
.tracking-tighter { letter-spacing: -1.0px; }
.border-white-sm { border: 2px solid white !important; }
</style>